import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { ActivatedRouteSnapshot } from '@angular/router';
import { EntityDetailResolver } from 'src/app/core/services/entity-detail.resolver';
import { LiftModuleService } from './lift-module.service';
import { LiftModuleDetail } from '../models/lift-module-detail.model';



@Injectable({ providedIn: 'root' })
export class LiftModuleDetailResolver extends EntityDetailResolver<LiftModuleService, LiftModuleDetail> {
  constructor(
    liftModuleService: LiftModuleService
  ) {
    super(liftModuleService);
  }
}
